import { SingularPaymentsFail } from '../../../../components/service/subscription/subscriptionPayment/SingularPaymentsFail';
export const SingularSubscriptionPaymentsFailPageView = () => {
  return <SingularPaymentsFail data-sentry-element="SingularPaymentsFail" data-sentry-component="SingularSubscriptionPaymentsFailPageView" data-sentry-source-file="fail.tsx" />;
};